import styles from "./styles.module.scss";
import Button from "@mui/material/Button/Button";
import Modal from "@mui/material/Modal/Modal";
import React, { useEffect, useState } from "react";
import closeIconModal from "../../../../../assets/_CloseIconModal_.svg";
import { IGetCurriculumDto } from "../../../../../@types/curriculum.type";
import { getCurriculumByResourceId } from "../../../../../services/api/Curriculum/curriculumService";
import { ChipsSkill } from "../../../../UserProfile/components/Chips";
import { CertificationGrid } from "../../../components/Grid/Certification";
import { LanguageGrid } from "../../../components/Grid/Language";

interface SkillDetailsModalProps {
  resourceId: string;
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SkillDetailsModal: React.FC<SkillDetailsModalProps> = ({
  openModal,
  setOpenModal,
  resourceId
}) => {

  const [curriculum, setCurriculum] = useState<IGetCurriculumDto>([]);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  useEffect(() => {
    loadInfo();
  }, [resourceId]);

  const loadInfo = async () => {
    const response = (await getCurriculumByResourceId(resourceId)) as IGetCurriculumDto;
    setCurriculum(response);
  }

  return (
    <>
      <Modal open={openModal} onClose={handleCloseModal}>
        <div className={styles.modal}>
          <div className={styles.header}>
            <h3>{curriculum.resourceName}</h3>
            <Button onClick={handleCloseModal} className={styles.iconButton}>
              {closeIconModal && <img src={closeIconModal} />}
            </Button>
          </div>
          <div className={styles.body}>
            {
              curriculum && curriculum.hardSkills && curriculum.hardSkills.length > 0 &&
              <div className={styles.hardSkills}>
                <h3>Hard Skills</h3>
                <div>
                  <ChipsSkill skills={curriculum.hardSkills} type="hardskill" />
                </div>
              </div>
            }
          
            {
              curriculum && curriculum.softSkills && curriculum.softSkills.length > 0 &&
                <div className={styles.softSkills}>
                <h3>Soft Skills</h3>
                <div>
                  <ChipsSkill skills={curriculum.softSkills} type="softskill"/>
                </div>
              </div>
            }
          
            {
              curriculum && curriculum.experiences && curriculum.experiences.length > 0 &&
              <div className={styles.experiences}>
                  <h3>Experiências</h3>
                  <div>
                    <ChipsSkill skills={curriculum.experiences} type="experiences" />
                  </div>
                </div>
            }

            {
              curriculum && curriculum.certifications && curriculum.certifications.length > 0 &&
              <div className={styles.certifications}>
                <h3>Certificações</h3>
                <div className={`${styles.gridContainer}`}>
                  <CertificationGrid certifications={curriculum.certifications} />
                </div>
              </div>
            }

            {
              curriculum && curriculum.languages && curriculum.languages.length > 0 &&
              <div className={styles.languages}>
                <h3>Idiomas</h3>
                <div className={`${styles.gridContainer}`}>
                  <LanguageGrid languages={curriculum.languages} />
                </div>
              </div>
            }
          </div>
        </div>
      </Modal>
    </>
  );
};
